/* DESPI — client de l'API de generation.
   Expose window.despiApi. Charge avant app.js et flow.js.

   Trois particularites par rapport a Turn Me Royal, imposees par notre architecture :

   1. TMR sert ses pages et son API sur turnmeroyal.com — meme origine, donc un simple
      cookie suffit. Chez nous les pages sont sur trydespi.com et l'API sur Vercel : le
      cookie serait un cookie TIERS, que Safari/iOS et le navigateur integre de Meta
      bloquent par defaut. Or c'est par la que passe 100 % du trafic publicitaire. On
      transporte donc le jeton de session dans un en-tete, et on le range dans un cookie
      PREMIERE PARTIE pose en JavaScript, qui lui fonctionne partout.

   2. La photo est REDIMENSIONNEE dans le navigateur avant l'envoi. Vercel refuse tout
      corps de requete depassant 4,5 Mo — une photo de telephone en fait souvent 6 a 12.
      En 1600 px elle tombe a ~300 Ko, ce qui accelere aussi beaucoup l'envoi en 4G.

   3. Le stockage local n'est pas fiable dans la WebView de Meta : la liste des creations
      vient du serveur, pas du navigateur.
*/
(function () {
  'use strict';

  var API = (window.DESPI_API_BASE || 'https://despi-backend.vercel.app').replace(/\/$/, '');
  var COOKIE = 'despi_sid';
  var MAX_SIDE = 1600;
  var POLL_MS = 1500;

  /* Intervalle de sondage BRUITE. Une campagne Meta amene les visiteurs par vagues : sans
     ce bruit, des milliers de navigateurs partis a la meme seconde sondent en rang serre
     et retombent ensemble sur nos fonctions, vague apres vague. Un ecart aleatoire de
     +/-25 % suffit a etaler la charge, et reste imperceptible a l'ecran. */
  function delaiSondage() {
    return Math.round(POLL_MS * (0.75 + Math.random() * 0.5));
  }

  /* ------------------------------------------------------- session (1re partie) */

  function lireSession() {
    var m = document.cookie.match(/(?:^|;\s*)despi_sid=([^;]+)/);
    if (m) return decodeURIComponent(m[1]);
    try { return localStorage.getItem(COOKIE) || ''; } catch (e) { return ''; }
  }

  function ecrireSession(token) {
    if (!token) return;
    var exp = new Date(Date.now() + 30 * 24 * 3600 * 1000).toUTCString();
    // pose sur NOTRE domaine : premiere partie, donc jamais bloque
    document.cookie = COOKIE + '=' + encodeURIComponent(token) + '; Path=/; Expires=' + exp + '; SameSite=Lax';
    try { localStorage.setItem(COOKIE, token); } catch (e) { /* mode prive */ }
  }

  /* ------------------------------------------------------------ adresses des pages

     Une page n'a pas la meme adresse selon l'endroit d'ou elle est servie : en preview
     locale c'est un fichier (`preview.html`), sur le theme Shopify c'est une page
     (`/pages/despi-preview`). L'adresse est donc fournie par la page qui nous charge, et
     ne figure JAMAIS en dur dans le code.

     C'est volontaire, et c'est la lecon d'un incident : le script de construction du theme
     traduisait ces liens par correspondance de texte, et ne trouvait pas `'preview.html?id='`
     en cherchant `'preview.html'`. Le build reussissait, le lien restait faux, et toutes les
     clientes arrivaient sur une page inexistante apres leur generation. Un lien qu'on
     n'ecrit pas est un lien qu'aucune traduction ne peut casser.
  */
  var PAGES_DEFAUT = {           // preview locale : les pages sont des fichiers
    create: 'index.html',
    preview: 'preview.html',
    customize: 'customize.html',
  };

  /* LE STYLE COURANT — quel tunnel la cliente est en train de parcourir.

     Chaque style a sa page de creation (`/pages/despi-create-in-loving-memory`) et sa page
     de configuration, parce qu'une publicite mene a UN style et que la page doit lui
     ressembler de bout en bout. Le style est donc pose par la page elle-meme
     (`window.DESPI_STYLE`, ecrit par le build), puis suit la cliente : il voyage dans
     l'adresse au passage sur le portrait, et change si elle choisit un autre style dans le
     panneau d'edition. Sans ca, une cliente venue par une annonce memoriale se retrouvait
     avec « Wild Pirates - Custom Portrait » sur son bon de commande. */
  // le slug vient parfois de l'adresse : on n'accepte que la forme attendue, jamais
  // n'importe quelle chaine placee par un visiteur dans l'URL
  var STYLE_VALIDE = /^[a-z0-9-]{1,60}$/;

  function styleCourant() {
    return window.DESPI_STYLE_COURANT || window.DESPI_STYLE || 'wild-pirates';
  }

  function definirStyle(slug) {
    if (slug && STYLE_VALIDE.test(slug)) window.DESPI_STYLE_COURANT = String(slug);
  }

  function page(nom) {
    var table = window.DESPI_PAGES || PAGES_DEFAUT;
    /* Une page par style. L'ADRESSE reste fournie par l'hebergeur — on ne fait que choisir
       la bonne entree de SA table. Aucune adresse n'est fabriquee ici : c'est la regle qui
       a coute un 404 generalise le jour ou elle a ete enfreinte. */
    var parStyle = table[nom + 'ParStyle'];
    if (parStyle && parStyle[styleCourant()]) return parStyle[styleCourant()];
    var p = table[nom];
    if (!p) throw new Error('page inconnue: ' + nom);
    return p;
  }

  /** Adresse d'une page avec ses parametres. `page('preview', {id: x})`. */
  function lien(nom, params) {
    var base = page(nom);
    if (!params) return base;
    var q = Object.keys(params)
      .filter(function (k) { return params[k] != null && params[k] !== ''; })
      .map(function (k) { return k + '=' + encodeURIComponent(params[k]); })
      .join('&');
    return q ? base + (base.indexOf('?') < 0 ? '?' : '&') + q : base;
  }

  /* --------------------------------------------------------------- appels HTTP */

  function entetes(extra) {
    var h = extra || {};
    var s = lireSession();
    if (s) h['x-despi-session'] = s;
    return h;
  }

  function traiter(res) {
    return res.json().catch(function () { return {}; }).then(function (body) {
      if (body.session) ecrireSession(body.session);
      if (!res.ok) {
        var e = new Error(body.error || 'http_' + res.status);
        e.status = res.status;
        e.body = body;
        throw e;
      }
      return body;
    });
  }

  /* ------------------------------------------------- redimensionnement navigateur */

  /**
   * Ramene la photo a MAX_SIDE et la reencode en JPEG. Le passage par un canvas
   * supprime aussi les metadonnees EXIF — dont la position GPS de la cliente.
   */
  function redimensionner(file) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        URL.revokeObjectURL(url);
        var w = img.naturalWidth, h = img.naturalHeight;
        var ratio = Math.min(1, MAX_SIDE / Math.max(w, h));
        var cw = Math.round(w * ratio), ch = Math.round(h * ratio);
        var c = document.createElement('canvas');
        c.width = cw; c.height = ch;
        c.getContext('2d').drawImage(img, 0, 0, cw, ch);
        c.toBlob(function (blob) {
          // si le navigateur ne sait pas produire de blob, on envoie l'original
          resolve(blob || file);
        }, 'image/jpeg', 0.9);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('image illisible')); };
      img.src = url;
    });
  }

  /* ------------------------------------------------------------------ endpoints */

  /** Envoie UNE photo. @returns {Promise<{uploadId, width, height, category}>} */
  function envoyerPhoto(file) {
    return redimensionner(file).then(function (blob) {
      return fetch(API + '/api/upload', {
        method: 'POST',
        headers: entetes({ 'Content-Type': 'image/jpeg' }),
        body: blob,
      }).then(traiter);
    });
  }

  /**
   * Lance une generation.
   * Deux voies : `uploadIds` apres un envoi de photos, ou `fromGeneration` pour relancer
   * a partir d'un portrait existant (Retry / Edit) — le serveur retrouve alors les photos
   * tout seul, la cliente n'a rien a renvoyer.
   * @returns {Promise<{generationId, category, remaining}>}
   */
  function generer(opts) {
    var corps = {
      personalize: opts.personalize || '',
      seed: opts.seed,
    };
    if (opts.fromGeneration) corps.fromGeneration = opts.fromGeneration;
    if (opts.uploadIds && opts.uploadIds.length) corps.uploadIds = opts.uploadIds;
    /* Les saisies declarees par le style (le nom sur l'affiche). On n'envoie RIEN quand il
       n'y en a pas : sur une relance, c'est l'absence qui dit au serveur de reprendre
       celles de la generation d'origine. Un objet vide voudrait dire « efface-les ». */
    if (opts.saisies && Object.keys(opts.saisies).length) corps.saisies = opts.saisies;
    // sur une relance, le style est herite si on n'en impose pas un nouveau
    if (opts.styleSlug || !opts.fromGeneration) corps.styleSlug = opts.styleSlug || 'wild-pirates';

    return fetch(API + '/api/generate', {
      method: 'POST',
      headers: entetes({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(corps),
    }).then(traiter);
  }

  /* ------------------------------------------------- images a la bonne taille */

  /* Largeur de l'apercu produit par le serveur (PREVIEW_W dans lib/images.js). Demander
     plus large ne sert a rien : le CDN de Supabase reduit, il n'agrandit jamais. */
  var SOURCE_W = 1000;

  /**
   * Adresse de l'apercu redimensionne a la taille REELLEMENT affichee.
   *
   * On servait le meme fichier de 243 Ko a tout le monde, y compris a des vignettes de
   * 65 px. Le CDN de Supabase sait redimensionner a la volee et met le resultat en cache :
   * une vignette tombe a une quinzaine de Ko. Tout le trafic publicitaire arrive sur
   * mobile en 4G dans la WebView de Meta, ou chaque kilo-octet se paie en attente.
   *
   * Les adresses qui ne sont pas des objets Supabase (assets du theme, images encore
   * hebergees ailleurs) ressortent inchangees.
   *
   * @param {string} url        adresse rendue par l'API
   * @param {number} largeurCss largeur d'affichage en pixels CSS
   */
  function image(url, largeurCss) {
    if (!url || url.indexOf('/storage/v1/object/public/') < 0) return url;
    // un ecran retina affiche 2 a 3 pixels physiques par pixel CSS
    var dpr = Math.min(window.devicePixelRatio || 1, 3);
    var w = Math.min(Math.round(largeurCss * dpr), SOURCE_W);
    if (!(w > 0)) return url;
    return url.replace('/storage/v1/object/public/', '/storage/v1/render/image/public/') +
      (url.indexOf('?') < 0 ? '?' : '&') +
      'width=' + w + '&quality=' + (largeurCss <= 200 ? 70 : 80) + '&resize=contain';
  }

  /* Aucune requete ne doit rester pendante indefiniment : en 4G dans la WebView de Meta,
     une connexion peut se figer sans jamais echouer ni aboutir. Sans borne, la promesse
     n'est jamais tenue et l'ecran d'attente tourne dans le vide. */
  var DELAI_REQUETE_MS = 15000;

  function avecDelai(url, options) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var minuteur = setTimeout(function () { if (ctrl) ctrl.abort(); }, DELAI_REQUETE_MS);
    var o = options || {};
    if (ctrl) o.signal = ctrl.signal;
    return fetch(url, o).then(
      function (r) { clearTimeout(minuteur); return r; },
      function (e) { clearTimeout(minuteur); throw e; }
    );
  }

  /* Liste des styles proposables, servie par le backend.

     Elle n'est PAS ecrite dans le front : le carrousel affichait seize styles herites du
     site copie alors qu'un seul existe cote serveur, et choisir l'un des quinze autres
     bloquait la cliente sur « Please try again » sans issue. Le serveur est seul juge de
     ce qu'il sait generer, donc seul juge de ce qui s'affiche.

     Mise en cache pour la duree de la page : le panneau peut etre rouvert plusieurs fois. */
  var stylesEnCache = null;

  function styles() {
    if (stylesEnCache) return stylesEnCache;
    stylesEnCache = avecDelai(API + '/api/styles', { headers: entetes() })
      .then(traiter)
      .then(function (b) { return Array.isArray(b.styles) ? b.styles : []; })
      .catch(function (e) {
        // une liste indisponible ne doit pas empecher d'editer : le panneau se replie sur
        // le champ « Describe changes », qui lui ne depend d'aucun catalogue.
        stylesEnCache = null;
        if (window.despiTrace) window.despiTrace('styles_indisponibles', { message: e.message, status: e.status });
        return [];
      });
    return stylesEnCache;
  }

  /** Etat d'une generation. */
  function etat(id) {
    return avecDelai(API + '/api/generation/' + encodeURIComponent(id), { headers: entetes() }).then(traiter);
  }

  /* Au-dela, on cesse de sonder. Le serveur declare lui-meme une generation bloquee au bout
     de cinq minutes ; ce plafond ne sert donc qu'au cas ou il ne repond plus du tout. */
  var ABANDON_MS = 300000;

  /**
   * Sonde jusqu'a la fin. `onProgress` recoit chaque etat intermediaire.
   *
   * DEUX FAMILLES D'ERREURS, ET C'EST TOUTE LA DIFFERENCE. Une coupure reseau ou une panne
   * passagere se rattrapent en reessayant — le backend est concu pour repondre « en cours »
   * plutot que d'echouer. Mais un 404 (generation inconnue) ou un 410 (expiree) ne se
   * repareront jamais : reessayer indefiniment laissait l'ecran d'attente tourner sans fin,
   * le bouton « Create » desactive et la cliente sans aucune issue. La page etait morte.
   */
  function attendre(id, onProgress) {
    var debut = Date.now();
    return new Promise(function (resolve, reject) {
      (function tick() {
        etat(id).then(function (s) {
          if (onProgress) onProgress(s);
          if (s.status === 'COMPLETED') return resolve(s);
          if (s.status === 'FAILED') return reject(Object.assign(new Error('generation_failed'), { retryable: s.retryable }));
          if (Date.now() - debut > ABANDON_MS) {
            // La cliente a attendu cinq minutes et repart sans rien. Consigne : c'est le
            // point d'abandon le plus couteux du parcours, et rien cote serveur ne le voit.
            if (window.despiTrace) window.despiTrace('abandon_generation', { message: 'trop longue', generationId: id, attente: Date.now() - debut });
            return reject(Object.assign(new Error('generation_trop_longue'), { status: 504 }));
          }
          setTimeout(tick, delaiSondage());
        }).catch(function (e) {
          // definitif : la generation n'existe pas ou n'existe plus, insister est vain
          if (e && (e.status === 404 || e.status === 410)) return reject(e);
          // passager : on retente, mais pas eternellement
          if (Date.now() - debut > ABANDON_MS) {
            if (window.despiTrace) window.despiTrace('abandon_generation', { message: 'injoignable : ' + (e && e.message), generationId: id, statut: e && e.status, attente: Date.now() - debut });
            return reject(Object.assign(new Error('generation_injoignable'), { status: 504 }));
          }
          setTimeout(tick, delaiSondage());
        });
      })();
    });
  }

  /**
   * Transforme le panier en articles achetables et emmene au checkout Shopify.
   *
   * Le navigateur n'envoie AUCUN prix : il decrit ce qu'il veut, le serveur calcule le
   * tarif et cree les variantes. Puis on passe par /cart/add.js, seule voie qui conserve
   * de facon fiable les proprietes de ligne — c'est d'elles que depend le relay vers
   * l'imprimeur. Depuis un autre domaine (preview locale), on retombe sur le permalien.
   */
  function checkout(items) {
    return fetch(API + '/api/checkout', {
      method: 'POST',
      headers: entetes({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ items: items }),
    }).then(traiter).then(function (r) {
      var surShopify = /(^|\.)myshopify\.com$|trydespi\.com$/.test(location.hostname);
      if (!surShopify) return r;   // preview locale : on rend l'info sans naviguer
      return avecDelai('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: r.items.map(function (i) {
          return { id: i.variantId, quantity: i.quantity, properties: i.properties };
        }) }),
      }).then(function (res) {
        // La reponse de Shopify n'etait PAS verifiee : on redirigeait vers le paiement des
        // que la requete aboutissait, meme si la ligne avait ete refusee (variante
        // indisponible, 422...). La cliente arrivait alors sur un checkout vide, sans le
        // moindre message — une vente perdue en silence, et impossible a diagnostiquer.
        if (res.ok) { window.location.href = '/checkout'; return r; }
        return res.json().catch(function () { return {}; }).then(function (corps) {
          var e = new Error(corps.description || corps.message || 'cart_add_refuse');
          e.status = res.status;
          e.body = corps;
          // Dernier metre avant le paiement : le serveur ne verra jamais ce refus, il vient
          // de Shopify et il est adresse au navigateur. Sans cette ligne, invisible.
          if (window.despiTrace) window.despiTrace('panier_refuse', { message: e.message, statut: res.status, articles: (r.items || []).length });
          throw e;
        });
      });
    });
  }

  /** Portraits deja generes par cette session (« Continue Creating »). */
  function creations() {
    return fetch(API + '/api/creations', { headers: entetes() })
      .then(traiter)
      .then(function (b) { return b.creations || []; })
      .catch(function () { return []; });
  }

  /** Enchaine envoi des photos + generation. `onStep` suit l'avancement. */
  /**
   * Envoie les photos PUIS lance la generation.
   *
   * Les envois sont PARALLELES. Chaque photo coute ~5,5 s cote serveur, dont l'essentiel
   * est la detection des sujets — du temps d'attente, pas du calcul chez nous. En serie,
   * une famille de quatre photos payait 22 s avant meme que la generation commence ; en
   * parallele elle en paie ~6, comme une photo seule.
   *
   * L'ORDRE EST CONSERVE par indice, jamais par ordre d'arrivee : le prompt designe les
   * images par lettre (A, B, C...) et cet ordre doit correspondre exactement a celui de
   * `image_urls`. Un `push()` au fil des reponses melangerait les roles.
   */
  function creerPortrait(opts, onStep) {
    var files = opts.files || [];
    var ids = new Array(files.length);
    var faits = 0;

    if (onStep) onStep({ etape: 'upload', index: 0, total: files.length });

    return Promise.all(files.map(function (f, i) {
      return envoyerPhoto(f).then(function (r) {
        ids[i] = r.uploadId;
        faits++;
        if (onStep) onStep({ etape: 'upload', index: faits, total: files.length });
      });
    })).then(function () {
      if (onStep) onStep({ etape: 'generation' });
      return generer({
        styleSlug: opts.styleSlug, uploadIds: ids,
        personalize: opts.personalize, saisies: opts.saisies,
      });
    });
  }

  window.despiApi = {
    base: API,
    page: page,
    lien: lien,
    style: styleCourant,
    definirStyle: definirStyle,
    session: lireSession,
    styles: styles,
    envoyerPhoto: envoyerPhoto,
    generer: generer,
    etat: etat,
    image: image,
    attendre: attendre,
    creations: creations,
    creerPortrait: creerPortrait,
    checkout: checkout,
  };
})();
